<div #container>
  <!--
    Gated on the resolved dataset, not just on the list arriving: the shell
    picks which dataset to open only once user info has settled, and anything
    rendered before that would read an empty `crd` and cache it. On the
    `crd/:crd/plantation-table/:plantationTable` route the URL supplies both,
    so there is nothing to wait for.
  -->
  @if (hasRouteParams || (crdStateService.selectedDataset$ | async)) {
    <router-outlet></router-outlet>
  } @else if ((crdStateService.datasets$ | async)?.length === 0) {
    <ng-template *ngTemplateOutlet="emptyDataset" />
  } @else {
    <ng-template *ngTemplateOutlet="datasetLoading" />
  }
</div>

<ng-template #emptyDataset>
  <app-empty-state
    class="no-dataset-found"
    description="DASHBOARD.EMPTY_STATE.NO_DATASET_DESC"
    icon="map"
    title="DASHBOARD.EMPTY_STATE.NO_DATASET_TITLE" />
</ng-template>

<ng-template #datasetLoading>
  <div
    class="flex align-items-center justify-content-center"
    style="height: 90vh">
    <p-progress-spinner />
  </div>
</ng-template>
